<pk-broker-modal customBodyClass="pb-0" customFooterClass="justify-content-center">
	<ng-template #headerTemplate>
		<h5 class="modal-title">Generate LOA/LOE</h5>
	</ng-template>
	<ng-template #bodyTemplate>
		<form [formGroup]="formGroup" *ngIf="formGroup">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12">
						<p class="black-text">Which of the following documents do you wish to generate and download/send to your customer?</p>
					</div>
				</div>
				<div class="row">
					<div class="col-4">
						<label>Letter of Authorization (LOA)</label>
					</div>
					<div class="col-8">
						<div class="row">
							<div class="col-4 form-element-container">
								<div class="custom-control custom-radio">
									<input class="custom-control-input" type="radio" id="addLOASend" formControlName="addLOA" value="send" />
									<label class="custom-control-label" for="addLOASend">{{ latestLoaSentDate ? 'Resend ' : 'Send' }}</label>
									<p class="smaller-text" *ngIf="latestLoaSentDate">Last Sent On {{ latestLoaSentDate | date: 'MM/dd/yyyy' }}</p>
								</div>
							</div>
							<div class="col-4 form-element-container">
								<div class="custom-control custom-radio">
									<input class="custom-control-input" type="radio" id="addLOADownload" formControlName="addLOA" value="download" />
									<label class="custom-control-label" for="addLOADownload">Download</label>
									<p class="smaller-text" *ngIf="latestLoaDownloadedDate">Last Downloaded On {{ latestLoaDownloadedDate | date: 'MM/dd/yyyy' }}</p>
								</div>
							</div>
							<div class="col-4 form-element-container">
								<div class="custom-control custom-radio">
									<input class="custom-control-input" type="radio" id="addLOANone" formControlName="addLOA" [value]="null" />
									<label class="custom-control-label" for="addLOANone">None</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-4">
						<label>Letter of Exclusivity (LOE)</label>
					</div>
					<div class="col-8">
						<div class="row">
							<div class="col-4 form-element-container">
								<div class="custom-control custom-radio">
									<input class="custom-control-input" type="radio" id="addLOESend" formControlName="addLOE" value="send" />
									<label class="custom-control-label" for="addLOESend">{{ latestLoeSentDate ? 'Resend ' : 'Send' }}</label>
									<p class="smaller-text" *ngIf="latestLoeSentDate">Last Sent On {{ latestLoeSentDate | date: 'MM/dd/yyyy' }}</p>
								</div>
							</div>
							<div class="col-4 form-element-container">
								<div class="custom-control custom-radio">
									<input class="custom-control-input" type="radio" id="addLOEDownload" formControlName="addLOE" value="download" />
									<label class="custom-control-label" for="addLOEDownload">Download</label>
									<p class="smaller-text" *ngIf="latestLoeDownloadedDate">Last Downloaded On {{ latestLoeDownloadedDate | date: 'MM/dd/yyyy' }}</p>
								</div>
							</div>
							<div class="col-4 form-element-container">
								<div class="custom-control custom-radio">
									<input class="custom-control-input" type="radio" id="addLOENone" formControlName="addLOE" [value]="null" />
									<label class="custom-control-label" for="addLOENone">None</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row" *ngIf="form.addLOE.value">
					<div class="col-12 ml-3 form-element-container">
						<div class="custom-control custom-checkbox">
							<input class="custom-control-input" type="checkbox" id="addBranding" formControlName="addLogo" />
							<label class="custom-control-label" for="addBranding">Attach my branding (logo) to the final LOE document</label>
						</div>
					</div>
				</div>
			</div>
			<div class="alert alert-warning" *ngIf="err.group?.atLeastOneSelected">Please select to download/send at least the LOA or LOE.</div>
		</form>
	</ng-template>

	<ng-template #footerTemplate>
		<button type="button" class="btn btn-link" (click)="close()" [disabled]="submitDisabled">Cancel</button>
		<button type="button" class="btn btn-primary" (click)="submit()" [disabled]="submitDisabled">{{ submitText }}</button>
	</ng-template>
</pk-broker-modal>
